<template>
  <div id="dynamicPage">
    <van-nav-bar
      @click-left="left"
      @click-right="right"
      :title="ruleForm.pageHead"
      left-arrow
      v-if="!isWeiXin"
    >
      <template v-slot:left>
        <img src="@/assets/image/dynamicPage/return@2x.png" />
      </template>
      <template v-if="clientSource == 'app'" v-slot:right>
        <img src="@/assets/image/dynamicPage/fenxiang@2x.png" />
      </template>
    </van-nav-bar>

    <div class="container-wrapper">
      <div v-if="isWeiXin" class="backLeft" @click="left"></div>
      <div class="container" v-html="ruleForm.pageDetail"></div>
    </div>
    <van-dialog v-model="show" :show-confirm-button="false">
      <div class="dialog-wrapper">
        <div class="back-image"></div>
        <span>该页面已下架</span>
        <van-button @click="back">逛逛首页</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "dynamicPage",
  data() {
    return {
      show: false,
      clientSource: "h5",
      ruleForm: {
        pageHead: "", //标题
        pageDetail: "", //详情
        shareImage: "", //分享图
        shareHead: "", //分享标题
        shareDes: "", //分享描述
      },
    };
  },
  created() {
    this.clientSource = this.$route.query.clientSource == "app" ? "app" : "h5";
    this.queryDynamicPageById();
  },
  computed: {
    //是否是微信内置游览器
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.clientSource = "h5";
        document.title = this.ruleForm.pageHead;
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    right() {
      if (this.clientSource == "h5") {
        //link, imgUrl, desc, title
      } else {
        this.uniJump(2, this.ruleForm);
      }
    },
    //查询页面
    queryDynamicPageById() {
      if (this.$route.query.id) {
        this.$http
          .get(this.$api.queryDynamicPageById, {
            params: { id: this.$route.query.id },
          })
          .then((resp) => {
            let { code, ret } = resp;
            if (code == "200") {
              this.ruleForm = ret;
              let link = window.location.href;
              this.wxShare(
                link,
                this.ruleForm.shareHead,
                this.ruleForm.shareDes,
                this.ruleForm.shareImage
              );
              const regex = new RegExp("<img", "gi");
              this.ruleForm.pageDetail = this.ruleForm.pageDetail.replace(
                regex,
                `<img style="max-width: 100% !important; height: auto !important"`
              );
              this.show = false;
            } else if (code == "500") {
              this.ruleForm = ret;
              this.show = true;
              this.ruleForm.pageDetail = this.ruleForm.pageDetail.replace(
                regex,
                `<img style="max-width: 100% !important; height: auto !important"`
              );
            }
            document.title = this.ruleForm.pageHead;
          });
      }
    },

    left() {
      if (this.clientSource == "h5") {
        let str = "";
        let hostname = location.hostname;
        if (hostname.includes("dev")) {
          str = "https://devwap.liangbaba.com";
        } else if (hostname.includes("test")) {
          str = "https://testwap.liangbaba.com";
        } else if (hostname.includes("pre")) {
          str = "https://prewap.liangbaba.com";
        } else {
          str = "https://wap.liangbaba.com";
        }
        location.href = str;
      } else {
        this.uniJump(1);
      }
    },

    //返回
    back() {
      this.left();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
#dynamicPage {
  .appNav {
    /deep/ .van-nav-bar__left {
      display: none;
      img {
        width: 10px;
        height: 18px;
      }
    }
  }
  /deep/ .van-nav-bar {
    z-index: 9999;
    height: 48px;
    .van-nav-bar__title {
      height: 22px;
      font-size: 16px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      color: #333333;
    }
    .van-nav-bar__right {
      img {
        width: 20px;
        height: 20px;
      }
    }
    .van-nav-bar__left {
      img {
        width: 10px;
        height: 18px;
      }
    }
  }
  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }

  .container-wrapper {
    padding: 0 15px;
    .container {
      overflow: auto;
      background: #f6f6f6;
      // height: 500px;
      margin-bottom: 60px;
    }
    .backLeft {
      width: 30px;
      height: 30px;
      background: url(../../assets/image/dynamicPage/return.png) no-repeat;
      background-size: 100% 100%;
      position: fixed;
      top: 10px;
      left: 20px;
    }
  }

  /deep/ .van-dialog {
    width: 280px;
    height: 269px;
    padding: 20px 15px;
    background: #ffffff;
    border-radius: 6px;
    .van-dialog__content {
      height: 100%;
    }
    .dialog-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: column;
      .back-image {
        background: url("../../assets/image/dynamicPage/404@2x.png") no-repeat;
        background-size: cover;
        width: 180px;
        height: 132px;
      }
      span {
        height: 21px;
        font-size: 15px;
        font-family: "PingFangSC-Regular, PingFang SC";
        font-weight: 400;
        color: #999999;
      }
      .van-button {
        height: 36px;
        width: 100%;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffa921 0%, #ff8002 100%);

        .van-button__text {
          width: 60px;
          height: 21px;
          font-size: 15px;
          font-family: "PingFangSC-Semibold, PingFang SC";
          font-weight: 600;
          color: #ffffff;
          line-height: 21px;
        }
      }
    }
  }

  .backLeft {
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/dynamicPage/index.vue